<div class="container-fluid pt-3 mobile-p0">
    <div class="rightBody">
        <app-status-bar [step]="{}"></app-status-bar>

    </div>
</div>
